module.exports = __webpack_public_path__ + "img/fm.3f19d612.svg";